import { DownloadSimpleIcon, XIcon } from "@phosphor-icons/react";

import Button, { ButtonSize, ButtonVariant } from "@gx/dls/buttons/Button";
import Chip from "@gx/dls/chips/Chip";
import HelpIcon from "@gx/dls/icons/HelpIcon";
import Text, { TextWeight } from "@gx/dls/text/Text";
import Tooltip, { TooltipPosition } from "@gx/dls/tooltip/Tooltip";
import {
  ProjectArtifactContentType,
  ProjectArtifactType,
} from "@gx/ts-contracts/services/database/models/public_pb";
import { ProjectArtifactResource } from "@gx/ts-contracts/services/ontology/resources/artifact_pb";

import BaseToolbar from "@/layouts/components/BaseToolbar";

import {
  PROJECT_ARTIFACT_CONTENT_TYPE_TO_FILE_EXTENSION_MAP,
  PROJECT_ARTIFACT_TYPE_TO_NAME_MAP,
} from "@/pages/projects/components/project/settings/artifacts/constants";

import { convertProtobufTimestampToDate, formatDateTime } from "@/utils/datetimes";

interface ArtifactContentViewerHeaderProps {
  artifact: ProjectArtifactResource;
  onDownload: () => void;
  onClose: () => void;
}

const ArtifactContentViewerHeader = ({
  artifact,
  onDownload,
  onClose,
}: ArtifactContentViewerHeaderProps) => {
  return (
    <BaseToolbar
      leadingActions={[
        <Text key="name" weight={TextWeight.MEDIUM}>
          {PROJECT_ARTIFACT_TYPE_TO_NAME_MAP[artifact?.type ?? ProjectArtifactType.UNSPECIFIED]}
        </Text>,
        <Chip
          key="content-type"
          label={`.${
            PROJECT_ARTIFACT_CONTENT_TYPE_TO_FILE_EXTENSION_MAP[
              artifact?.contentType ?? ProjectArtifactContentType.UNSPECIFIED
            ]
          }`}
        />,
        <Tooltip
          key="help-tooltip"
          position={TooltipPosition.RIGHT}
          body={`This file was created on ${artifact.createdAt ? formatDateTime(convertProtobufTimestampToDate(artifact.createdAt).toISOString()) : "—"}`}
        >
          <HelpIcon />
        </Tooltip>,
      ]}
      trailingActions={[
        <Button
          key="download"
          label="Download"
          icon={DownloadSimpleIcon}
          variant={ButtonVariant.TERTIARY}
          size={ButtonSize.SMALL}
          onClick={onDownload}
        />,
        <Button
          key="close"
          icon={XIcon}
          variant={ButtonVariant.TERTIARY}
          size={ButtonSize.SMALL}
          onClick={onClose}
        />,
      ]}
    />
  );
};

export default ArtifactContentViewerHeader;
